import { FormProvider, useForm } from "react-hook-form";
import { GetRepayment, GetRepaymentAmountMax } from "store/api/repay";
import { useEffect, useMemo, useState } from "react";

import CoinDrawerSelect from "components/CoinDrawerSelect";
import { Grid } from "@mui/material";
import RepayAmount from "./Components/RepayAmount";
import RepayInfo from "./Components/RepayInfo";
import RepaySubmit from "./Components/RepaySubmit";
import { borrowOrRepaySchema } from "utils/validations/borrowOrRepaySchema";
import http from "config/http";
import { repeat } from "utils/helpers/interval";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

let getRepayAmountMaxInterval;

function Repay({ onClose }) {
  const notify = useNotify();

  const [repayInitial, setRepayInitial] = useState();
  const [repayAmountMax, setRepayAmountMax] = useState();
  const [loading, setLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const coinId = +searchParams.get("repay") || 1;

  const methods = useForm({
    defaultValues: {
      coinId,
      amount: "",
    },
    resolver: yupResolver(borrowOrRepaySchema()),
  });

  const { reset } = methods;

  const getRepayment = async () => {
    try {
      const { data } = await http.get(GetRepayment(coinId));

      setRepayInitial(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const getRepaymentAmountMax = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(GetRepaymentAmountMax(coinId));
      setRepayAmountMax(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (repayInitial?.validSeconds && coinId) {
      getRepaymentAmountMax();

      clearInterval(getRepayAmountMaxInterval);

      getRepayAmountMaxInterval = repeat({
        action: () => getRepaymentAmountMax(),
        time: repayInitial?.validSeconds * 1000,
      });
    }

    return () => {
      clearInterval(getRepayAmountMaxInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinId, repayInitial]);

  const handleChangeCoin = (data) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, repay: data?.id });
  };

  const selectedCoin = useMemo(
    () => repayInitial?.lisCoin?.find((coin) => coin?.id === coinId),
    [repayInitial, coinId]
  );

  useEffect(() => {
    getRepayment();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset((formValues) => ({
      ...formValues,
      amount: "",
      coinId,
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinId, reset]);

  return (
    <FormProvider {...methods}>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CoinDrawerSelect
              coinList={repayInitial}
              onCoinClick={handleChangeCoin}
              selectedCoin={selectedCoin}
            />
          </Grid>

          <RepayAmount
            loading={loading}
            repayAmountMax={repayAmountMax}
            selectedCoin={selectedCoin}
          />

          <RepayInfo
            repayAmountMax={repayAmountMax}
            selectedCoin={selectedCoin}
          />

          <RepaySubmit
            onClose={onClose}
            repayAmountMax={repayAmountMax}
            selectedCoin={selectedCoin}
          />
        </Grid>
      </form>
    </FormProvider>
  );
}

export default Repay;
